import * as Immutable from 'seamless-immutable';
import {
  LOCATION_TREE_WILL_READ,
  LOCATION_TREE_READ_FAILED,
  LOCATION_TREE_READ_PAGINATION_FINISHED,
  LOCATION_TREE_READ_SUCCESS
} from '../actions';

const initialState = Immutable.from({
  allNodes: [],
  nodesDictionary: {},
  isFetching: false,
  error: null
});

export default (state = initialState, action) => {
  switch (action.type) {
    case LOCATION_TREE_WILL_READ:
      return state.merge({isFetching: true, error: null});
    case LOCATION_TREE_READ_SUCCESS: {
      const {results} = action.payload;
      const allNodes = state.allNodes.concat(results);
      const nodesDictionary = Object.assign({}, state.nodesDictionary);
      results.forEach(n => {
        nodesDictionary[n.id] = n;
      });
      return state.merge({allNodes, nodesDictionary});
    }
    case LOCATION_TREE_READ_PAGINATION_FINISHED:
      return state.merge({isFetching: false});
    case LOCATION_TREE_READ_FAILED:
      return state.merge({isFetching: false, error: true});
    default:
      return state;
  }
};
